<template lang="pug">
v-container
  alert(ref="alert")
  div.totalDebt
    p.mr-5.pt-5.subtitle(style="color: #fff") Te queda por pagar un total de
    h1.ml-8(style="color: #fff") {{ totalToPay | currency }}
  br
  v-data-table(
    :headers="headers"
    class="elevation-0"
    :items="pendings"
    hide-default-footer
    no-data-text="No hay cuentas por pagar"
    :loading="table.loading"
    loading-text="Cargando Movimientos..."
    )
    template(v-slot:item.created_at="{ item }")
      p {{ formatDate(item.created_at) }} hrs.
    template(v-slot:item.state="{ item }")
      v-chip(label :color="getColor(item.state)" :text-color="getColorText(item.state)" dark) {{ item.state }}
    template(v-slot:item.supplier="{ item }")
      p(v-if="item.supplier_name !== null && item.supplier_name !== '-'") {{ item.supplier_name }}
      p(v-else) Sin proveedor
    template(v-slot:item.credit_term="{ item }")
      p(v-if="!Number(item.credit_term)") {{ item.credit_term ? item.credit_term?.split('-').reverse().join('/') : '' }}
    template(v-slot:item.payment_total="{ item }")
      p {{ item.payment_total | currency }}
    //- template(v-slot:item.limit_date="{ item }")
    //-   p {{ formatDateDayShort(item.limit_date) }}
    template(v-slot:item.description="{ item }")
      p {{ item.description }} <br/> {{ item.check_number && `Cheque ${item.check_qty} - N° ${item.check_number}` }}
    template(v-slot:item.actions="{ item }")
      v-btn(style="background-color: #E1EAFF; color: #407BFF" elevation="0" @click="handleOpenConfirmPayment(item)")
        v-icon.mr-2(style="color: #407BFF" dense) mdi-cash-100
        span Pagar
  v-pagination.mt-4(v-model="page" :length="pageCount" circle color="primary" elevation=0)
  v-dialog(v-model="confirmPayment" transition="dialog-top-transition" width="450" content-class="elevation-0" style="border-radius: 16px;")
    v-card(style="padding: 50px 20px 20px 20px;")
      div.payment-img
      v-card-title.justify-center(style="color: #4C7AEC;" v-if="selectedPendingPayment.payment_total") ¿Seguro quieres pagar {{ selectedPendingPayment.payment_total | currency }}?
      v-card-actions
        v-row
          v-col(cols="6")
            v-btn(@click="confirmPayment = false" block elevation="0" color="#4C7AEC" outlined) Cancelar
          v-col(cols="6")
            v-btn.mr-5(color="#4C7AEC" dark @click="handlePay()" block) Confirmar
</template>
<script>
import { mapActions } from 'vuex'
import alert from '../shared/alert.vue'
export default {
  props: {
    tab: {
      type: Number,
      default: 2
    }
  },
  components: {
    alert
  },
  data () {
    return {
      page: 1,
      pageCount: 0,
      table: {
        loading: false
      },
      headers: [
        { text: 'Fecha Ingreso deuda', value: 'created_at' },
        { text: 'Glosa', value: 'description' , width: '33%' },
        { text: 'Tipo de Pago', value: 'payment_gateway' },
        { text: 'Proveedor', value: 'supplier' },
        { text: 'Pagar hasta', value: 'credit_term' },
        { text: 'Monto', value: 'payment_total' },
        // { text: 'Pagar hasta', value: 'credit_term' },
        { text: 'Acciones', value: 'actions' }
      ],
      pendings: [],
      totalToPay: 0,
      confirmPayment: false,
      selectedPendingPayment: {}
    }
  },
  methods: {
    ...mapActions('inventory', ['listPendingPayments', 'payPendingPayment']),
    formatDate (date) {
      return new Intl.DateTimeFormat('cl-ES', { day: '2-digit', month: '2-digit', year: 'numeric', hour: 'numeric', minute: 'numeric' }).format(new Date(date))
    },
    formatDateDay (date) {
      return new Intl.DateTimeFormat('cl-ES', { dateStyle: 'long' }).format(new Date(date))
    },
    formatDateDayShort (date) {
      return new Intl.DateTimeFormat('cl-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(date))
    },
    getColor (type) {
      return type === 'Pendiente' ? '#F19292' : '#FFD6EC'
    },
    getColorText (type) {
      return type === 'Pendiente' ? '#820000' : '#A71A5E'
    },
    async fetchData () {
      this.table.loading = true
      await this.listPendingPayments({ params: { page: this.page } }).then(
        response => {
          if (response.status === 200) {
            this.pendings = response.data.results.map((data) => {
              return {
                ...data,
                limit_date: this.getPaymentUntil(data)
              }
            }).sort((a, b) => a.limit_date - b.limit_date)
            this.pageCount = Math.ceil(response.data.count / 10)
            this.totalToPay = response.data.pending_expenses
          } else {
            this.pendings = []
            this.totalToPay = 0
          }
        }
      )
      this.table.loading = false
    },
    getPaymentUntil (payment) {
      return payment.credit_term
    },
    handleOpenConfirmPayment (item) {
      this.confirmPayment = !this.confirmPayment
      this.selectedPendingPayment = item
    },
    handlePay () {
      const data = {
        state: 'Pagado',
        description: '',
        transaction_date: new Date(),
        aproved_by: null,
        id: this.selectedPendingPayment.id
      }
      this.payPendingPayment({ data }).then(
        response => {
          if (response.status === 200) {
            this.confirmPayment = false
            this.fetchData()
            this.$refs.alert.handleShowAlert('success', 'Pago realizado con éxito', true, 'green')
          }
        }
      )
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    tab (newVal) {
      if (newVal === 2) {
        this.fetchData()
      }
    },
    page () {
      this.fetchData()
    }
  }
}
</script>
<style lang="scss" scoped>
.totalDebt {
  height: 100px;
  background-image: url('./../../assets/img/total.png');
  background-size: cover;
  background-position: center;
  border-radius: 16px;
}

.subtitle {
  font-size: 16px;
  margin-left: 32px;
}
.v-application p {
  margin-bottom: 0;
}
.payment-img {
  height: 160px;
  background-image: url('./../../assets/img/money.png');
  background-size: contain;
  background-position: center;
}
</style>
